export interface SessionUser {
  id: string;
  email: string;
  displayName: string;
  role: "owner" | "assistant";
  mustChangePassword: boolean;
  encryptionSetupRequired?:boolean;
}

let csrfToken = "";
export const setCsrfToken = (value: string) => { csrfToken = value; };

export class ApiClientError extends Error {
  constructor(public readonly status: number, message: string, public readonly code?: string) { super(message); }
}

export async function api<T>(url: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (options.method && !["GET", "HEAD"].includes(options.method.toUpperCase())) headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(url, { credentials: "same-origin", ...options, headers });
  const data = response.headers.get("content-type")?.includes("application/json") ? await response.json() : null;
  if (!response.ok) throw new ApiClientError(response.status, data?.message ?? (response.status===413?"Die Datei überschreitet das Uploadlimit des Servers. Bei einer Backupdatei bitte das Backup-Uploadlimit prüfen lassen.":"Anfrage fehlgeschlagen."), data?.error);
  return data as T;
}

export function json(method: string, body?: unknown): RequestInit {
  return { method, body: body === undefined ? undefined : JSON.stringify(body) };
}
